import axios from '@_system/axios/axios.js'
export default {
	path: '/customersea',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get('moduleConfig/admin/customermanage.customersea', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	distribution(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/distribution/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	import(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			})
		})
	},
	export(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/export', data, (res) => {
				resolve(res.data)
			})
		})
	},
}
